module.exports = __webpack_public_path__ + "static/media/joomla.513f137c.svg";